import {useEffect} from 'react'

export default function MatricesPrivacyPolicyPage({ setShowNavBar }) {

    useEffect(() => setShowNavBar(false));

	return (
		<h2>Scheduling Matrices Privacy Policy</h2>
	)
}